import { Table } from 'antd';
import styled from 'styled-components';

const EssentialAgreement = () => {
  const columns = [
    {
      dataIndex: 'date',
      key: 'date',
      width: '23%'
    },
    {
      dataIndex: 'items',
      key: 'items',
      width: '30%'
    },
    {
      dataIndex: 'purpose',
      key: 'purpose',
      width: '47%'
    }
  ];

  const dataSource = [
    {
      date: '수집·이용 목적',
      items: '수집·이용하는 개인정보 항목',
      purpose: '보유기간'
    },
    {
      date: '회원 등록 및 관리',
      items: `[필수] 대표자명, 계약 종류 선택, 주소 
      
              [선택] 상호, 일반전화, 추천인코드 
              `,
      purpose: `
              1. 원칙: 회원 파기 요청시까지 
              2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
              - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)
              `
    },
    {
      date: '회원 식별 및 미성년자 식별',
      items: '아이디, 이름, 휴대폰번호, 생년월일, 성별',
      purpose: `1. 원칙: 회원 탈퇴시까지
                2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
                - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)
                `
    },
    {
      date: '서비스 결제',
      items: `카드사명, 카드번호, 유효기간
              은행명, 계좌번호, 입금자명
              `,
      purpose: `1. 원칙: 회원 탈퇴시까지
                2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
                - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)
                `
    },
    {
      date: '이벤트 및 프로모션 이용시',
      items: `[필수]
              성명, 휴대폰 번호, 이메일, 거주지, 계좌정보(은행명, 예금주명, 계좌번호)`,
      purpose: `이벤트 당첨 및 컨테스트 수상시 상품 배송`
    }
  ];

  return (
    <>
      <Text>
        ㈜엑스바디가 제공하는 서비스를 이용하도록 하기 위해서 그 수집 및 이용이 필요한 최소한의
        개인정보이므로 해당 항목에 동의를 해 주셔야 서비스 이용이 가능합니다. 본인은 다음과 같이
        본인의 개인정보를 수집/이용하고 본 동의서에서 정하는 경우에 한하여 제3자에게 제공하는 것을
        동의합니다.
      </Text>
      <Table
        dataSource={dataSource.map((item, index) => ({
          ...item,
          key: index
        }))}
        bordered
        columns={columns}
        showHeader={false}
        pagination={false}
      />
    </>
  );
};

export default EssentialAgreement;

const Text = styled.p`
  padding-bottom: 16px;
`;
